import React, { PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";

import colorSeeds from "../../seeds/web-theme.json";

import { WebAppTheme } from "../../types/web";

type ThemeFormProps = PropsWithChildren<{}>;

export default function WebThemeForm({ children }: ThemeFormProps) {
  const form = useForm<WebAppTheme>({
    defaultValues: {
      text: {
        heading: colorSeeds.text.heading,
        body: colorSeeds.text.body,
        danger: colorSeeds.text.danger,
        success: colorSeeds.text.success,
        warning: colorSeeds.text.warning,
      },
      button: {
        primary: colorSeeds.button.primary,
        secondary: colorSeeds.button.secondary,
        tertiary: colorSeeds.button.tertiary,
      },
      surfaces: {
        body: colorSeeds.surfaces.body,
        primary: colorSeeds.surfaces.primary,
        secondary: colorSeeds.surfaces.secondary,
        components: {
          skeleton: colorSeeds.surfaces.components.skeleton,
          input: colorSeeds.surfaces.components.input,
          authPageStatus: colorSeeds.surfaces.components.authPageStatus,
        },
      },
      borders: {
        primary: colorSeeds.borders.primary,
        secondary: colorSeeds.borders.secondary,
        tertiary: colorSeeds.borders.tertiary,
      },
      highlights: colorSeeds.highlights,
      components: {
        alert: {
          success: {
            background: colorSeeds.components.alert.success.background,
            text: colorSeeds.components.alert.success.text,
            border: colorSeeds.components.alert.success.border,
          },
          danger: {
            background: colorSeeds.components.alert.danger.background,
            text: colorSeeds.components.alert.danger.text,
            border: colorSeeds.components.alert.danger.border,
          },
        },
        toast: {
          success: colorSeeds.components.toast.success,
          error: colorSeeds.components.toast.error,
          info: colorSeeds.components.toast.info,
        },
        spinners: colorSeeds.components.spinners,
        navBar: {
          background: colorSeeds.components.navBar.background,
          text: colorSeeds.components.navBar.text,
          button: {
            background: colorSeeds.components.navBar.button.background,
            content: {
              default: colorSeeds.components.navBar.button.content.default,
              accent: colorSeeds.components.navBar.button.content.accent,
            },
          },
        },
        tags: {
          orderStatus: {
            text: colorSeeds.components.tags.orderStatus.text,
            background: colorSeeds.components.tags.orderStatus.background,
          },
          preparationTime: {
            text: colorSeeds.components.tags.preparationTime.text,
            background: colorSeeds.components.tags.preparationTime.background,
          },
        },
        socialAuth: {
          facebook: colorSeeds.components.socialAuth.facebook,
          apple: colorSeeds.components.socialAuth.apple,
        },
        calendar: {
          text: colorSeeds.components.calendar.text,
          background: colorSeeds.components.calendar.background,
        },
      },
    },
  });

  return <FormProvider {...form}>{children}</FormProvider>;
}
